<template>
    <div class="events">
        <div
            class="events-container"
            :class="eventClasses(event)"
            v-for="(event, index) in events"
            v-if="index <= showLimit - 1"
            @click.stop="eventClick(event)"
        >
            <div class="day-number">
                {{ day.monthDay }}
            </div>
            <div class="event"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        day: {
            type: Object,
        },
        events: {
            type: Array,
            default: () => [],
        },
        showLimit: {
            type: Number,
            default: 3,
        },
        locale: {
            type: String,
            default: 'en',
        },
    },
    methods: {
        eventClick(event) {
            this.$emit('eventClicked', event);
        },
        eventClasses(event) {
            return event.class ? event.class : '';
        },
        selectDay() {
            this.$emit('showMore', this.events);
        },
    },
};
</script>

<style>
.events {
}

.event {
    height: 50px;
    max-width: 50px;
    cursor: pointer;
    font-size: 12px;
    color: #fff;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #0e9604;
}

.more-link {
    cursor: pointer;
    padding-left: 8px;
    padding-right: 2px;
    color: rgba(0, 0, 0, 0.38);
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// events-box.vue?5851b45a